export default __webpack_public_path__ + "static/media/objects-lightbulb.5d875a84.svg";